var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "PaymentCheck",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-check","viewBox":"0 0 500 312"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <rect width="500" height="312" fill="#F8F8F8" className="dibsvg-color-holder"/>
  <path d="M446.34 190.43l-26.146-34.514-7.321 8.367v26.146h-13.596v-82.622h13.596v39.742l31.375-39.742h16.734l-31.376 38.696 34.513 43.926h-17.78zm-143.282-40.79c0-25.1 17.78-42.879 41.834-42.879 15.688 0 26.147 8.367 31.376 18.825l-11.504 6.275c-4.184-6.275-11.505-11.504-19.872-11.504-15.687 0-27.192 12.55-27.192 29.284 0 16.734 11.505 29.284 27.192 29.284 8.367 0 15.688-5.23 19.872-11.505l11.504 6.275c-6.275 9.413-15.688 18.826-31.376 18.826-24.054-1.046-41.834-17.78-41.834-42.88zm-76.347 40.79v-82.623h54.384v12.55h-40.788v21.963h39.743v12.55h-39.743v23.009h40.788v12.55h-54.384zM33.23 149.64c0-25.1 17.78-42.879 41.834-42.879 15.688 0 26.146 8.367 31.376 18.825l-11.505 6.275c-4.183-7.32-11.504-12.55-19.871-12.55-15.688 0-27.192 12.55-27.192 29.284 0 16.734 11.504 30.33 27.192 30.33 8.367 0 15.688-5.23 19.871-11.505l11.505 6.275c-6.276 9.413-15.688 18.826-31.376 18.826-24.055-1.046-41.834-17.78-41.834-42.88zm150.602 40.79v-35.56h-40.788v35.56h-13.596v-82.623h13.596v34.513h40.788v-34.513h14.642v82.622h-14.642z" className="dibsvg-color-letters"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/payment-check.svg